import { SowingCalendarContainer } from '@modules/sowing-calendar/containers/sowing_calendar_container';
import { SowingCalendarView } from '@modules/sowing-calendar/views/sowing_calendar_view';

export function CalendarScreen() {
  return <SowingCalendarContainer View={SowingCalendarView} />;
}
